export const ComparisonData = [
    {
        id: 1,
        title: "Подготовка документов\n" +
            "для прохождения экзамена",
        otherSchoolPrice: "+8 000 ₽",
        ourSchoolPrice: "Входит в стоимость"
    },
    {
        id: 2,
        title: "Топливные сборы и амортизация\n" +
            "(каждое занятие)",
        otherSchoolPrice: "+ 1 000 ₽",
        ourSchoolPrice: "Входит в стоимость"
    },
    {
        id: 3,
        title: "Платный индивидуальный график",
        otherSchoolPrice: "+ 10 000 ₽",
        ourSchoolPrice: "Входит в стоимость"
    },
    {
        id: 4,
        title: "Платный ускоренный выход\n" +
            "на практику",
        otherSchoolPrice: "+8 000 ₽",
        ourSchoolPrice: "Входит в стоимость"
    }
]